import React from "react"
import {Chip} from "@mui/material"

import {offerStatusColors} from "./offerStatusColors"

import {colors} from "@indebted/theme/colors"
import {CustomerOffer} from "@indebted/api"
import {getOfferStatus, OfferStatus} from "@indebted/api/customerOffersAPI"

type OfferStatusChipProps = {
	offer: CustomerOffer
}

const offerStatusLabels: Record<OfferStatus, string> = {
	available: "AVAILABLE",
	upcoming: "UPCOMING",
	expired: "EXPIRED",
	revoked: "REMOVED",
	none: "",
}

const offerStatusTextColors: Record<OfferStatus, string> = {
	available: colors.primary.white,
	upcoming: colors.primary.white,
	expired: colors.gray["500"],
	revoked: colors.gray["500"],
	none: colors.gray["500"],
}

export function OfferStatusChip({offer}: OfferStatusChipProps) {
	const status = getOfferStatus(offer)

	return (
		<Chip
			label={offerStatusLabels[status] || offer.Status.toUpperCase()}
			size="small"
			role="status"
			aria-label={`offer status: ${offerStatusLabels[status] || offer.Status.toUpperCase()}`}
			style={{
				backgroundColor: offerStatusColors(status),
				color: offerStatusTextColors[status],
				height: "20px",
				fontSize: "0.7rem",
			}}
		/>
	)
}
